
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import DailyNumberDisplayerFilterable from '@/components/reports-v3/components/filterables/DailyNumberDisplayerFilterable.vue';
import moment from 'moment';
import FilterWidget from '@/components/reports-v3/components/codedWidgets/shared/FilterWidget.vue';
import {PermissionsGroup} from '@/store/models.def';
import {getTableName} from '@/worker/db/sqlHelpers';

@Component({
	components: {
		DailyNumberDisplayerFilterable,
	},
})
export default class DashboardCashInFlowNumberDisplayer extends FilterWidget {
    public get permissionIds(): PermissionsGroup[] {
        return ['dashboard'];
    }

    public filterIds: Array<
		| 'date'
		| 'dateAsOf'
		| 'dateRange'
		| 'stockItems'
		| 'agents'
		| 'customers'
		| 'suppliers'
	> = ['dateAsOf'];

	public todayAmount = 0;

	public get expensiveHook() {
		const { selectedAsOfDate } = this;
		return JSON.stringify([selectedAsOfDate]);
	}

	public async expensiveCalc() {
		this.generateLoadingText(0.2, 0.3);

		const dayStart = moment(this.selectedAsOfDate).startOf('day').valueOf();
		const dayEnd = moment(this.selectedAsOfDate).endOf('day').valueOf();
		const table = getTableName('dashboardCashFlow');

		const jobId = this.currentJobId;
		const queryHead = await this._ensureTablesLoaded(['dashboardCashFlow']);
		this.checkInterrupted(jobId);
		this.generateLoadingText(0.5);

		const result = await queryHead.rawQuery(`
			SELECT SUM(TRY_CAST("CASHINFLOW" AS DOUBLE)) as total
			FROM ${table}
			WHERE TRY_CAST("DOCDATE" AS BIGINT) BETWEEN ${dayStart} AND ${dayEnd}
		`);
		this.checkInterrupted(jobId);

		this.todayAmount = Number(result[0] && result[0].total) || 0;

		this.generateLoadingText(1);
		this.saveHistory('todayAmount');
	}
}
